module.exports = __webpack_public_path__ + "60c698f2a7b1d076502fd339aeddbc59.png";